module.exports = __webpack_public_path__ + "55dcda2c5f21ca183f770755a5bdc992.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/wellbeing/wellbeing-cover-summer-2013-2.jpg
 ** module id = 472
 ** module chunks = 0
 **/